
import React from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import CssBaseline from '@material-ui/core/CssBaseline';
import PropTypes from "prop-types";
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
    hideMessage,
    showAuthLoader,
    recuperarSenha,
    iniciaRecuperarSenha
} from 'actions/RecuperarSenhaApp';

class RecuperarSenha extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            senha: '',
            confirmarSenha: ''
        };
    }
    componentDidMount() {
        const { token } = this.props.match.params;
        this.props.iniciaRecuperarSenha(token);
    }
    componentDidUpdate(prevProps) {
        if (this.props.showMessage && this.props.showMessage !== prevProps.showMessage) {
            setTimeout(() => {
                this.props.hideMessage();
            }, 100);
        }
    }

    handleSubmit = () => {
        const { senha, confirmarSenha } = this.state;

        if (!senha || !confirmarSenha) {
            NotificationManager.error('Preencha todos os campos');
            return;
        }

        if (senha !== confirmarSenha) {
            NotificationManager.error('As senhas não conferem');
            return;
        }

        this.props.showAuthLoader();
        this.props.recuperarSenha({
            senha,
            confirmarSenha,
            token: this.props.recuperaSenha.bearer
        });
    };
    renderConteudoCard() {
        const { senha, confirmarSenha } = this.state;
        const { loader } = this.props;
        if (this.props.recuperaSenha.trocaSenhaSucesso) {
            return (
                <>
                    <Typography variant="h6" gutterBottom>
                        Senha alterada com sucesso 🎉
                    </Typography>

                    <Typography variant="body2" align="center">
                        Sua senha foi alterada com sucesso.
                        Agora é só acessar o aplicativo e entrar com a nova senha.
                    </Typography>
                </>
            );
        }

        if (this.props.recuperaSenha.trocaSenhaExpirada) {
            return (
                <>
                    <Typography variant="h6" color="error" gutterBottom>
                        Link expirado
                    </Typography>

                    <Typography variant="body2" align="center">
                        Este link de recuperação expirou.
                        Solicite uma nova recuperação de senha.
                    </Typography>
                </>
            );
        }

        // 👇 Caso padrão: formulário
        return (
            <>
                <Typography component="h1" variant="h6" style={{ marginTop: 20 }}>
                    Criar nova senha
                </Typography>

                <form noValidate style={{ width: '100%', marginTop: 16 }}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Nova senha"
                        type="password"
                        value={senha}
                        onChange={(e) => this.setState({ senha: e.target.value })}
                    />

                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Confirmar nova senha"
                        type="password"
                        value={confirmarSenha}
                        onChange={(e) => this.setState({ confirmarSenha: e.target.value })}
                    />

                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        style={{ marginTop: 16 }}
                        onClick={this.handleSubmit}
                    >
                        Alterar senha
                    </Button>
                </form>

                {loader && (
                    <Box mt={2}>
                        <CircularProgress />
                    </Box>
                )}
            </>
        );
    }

    render() {
        const {
            loader,
            showMessage,
            alertMessage
        } = this.props;

        return (
            <Grid
                container
                component="main"
                justify="center"
                alignItems="center"
                style={{ minHeight: '100vh' }}
            >
                <CssBaseline />

                <Grid
                    item
                    xs={11}
                    sm={8}
                    md={4}
                    lg={3}
                    component={Paper}
                    elevation={6}
                >
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        p={3}
                    >
                        <Link to="/" title="Uzer Tecnologia">
                            <img
                                src={require("assets/images/logotipo_transparente_fundoclaro.png")}
                                width="177"
                                height="61"
                                alt="Uzer Tecnologia"
                            />
                        </Link>

                        {/* 👇 Conteúdo condicional */}
                        {this.renderConteudoCard()}

                        {/* 👇 Mensagens globais */}
                        {showMessage && NotificationManager.error(alertMessage)}
                        <NotificationContainer />
                    </Box>
                </Grid>
            </Grid>
        );
    }

}


const mapStateToProps = (props) => {
    const { loader, alertMessage, showMessage, recuperaSenha } = props;
    return { loader, alertMessage, showMessage, recuperaSenha }
};

export default connect(mapStateToProps, {
    recuperarSenha,
    hideMessage,
    iniciaRecuperarSenha,
    showAuthLoader
})(RecuperarSenha);